import React from 'react'
import api from '~/api/endpoints'
import type {TAdminSignUpsResult} from '~/api/endpoints/admin/AdminSignUps'
import AdminLayout from '~/layouts/AdminLayout'
import AdminSignUpsUI from '~/pages/Admin/SignUps/stateless'
import type {IAdminRouteComponentProps} from '~/routing/Route/Admin'
import {isolateAdminRouteComponentProps} from '~/routing/Route/Admin'

interface IProps extends IAdminRouteComponentProps {}

interface IState {
  result: TAdminSignUpsResult | undefined
}

export default class AdminSignupsPage extends React.Component<IProps, IState> {
  state: IState = {
    result: undefined,
  }

  render() {
    return (
      <AdminLayout {...isolateAdminRouteComponentProps(this.props)}>
        <api.admin.signUps.PromiseManager
          params={{}}
          pathPieces={{}}
          onSuccess={result => this.setState({result})}
          then={initialResult => (
            <AdminSignUpsUI
              signups={(this.state.result ?? initialResult).signupRequests}
              approveSignUp={signupRequestId =>
                api.admin.approveSignUp.execute({}, {signupRequestId})
              }
              approveSignUpSubmitSuccess={result => this.setState({result})}
            />
          )}
        />
      </AdminLayout>
    )
  }
}
